<template>
<div id="app">

  <v-app id="inspire" light>
    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>

        <v-container fluid="">
          <v-card color="grey lighten-5" flat>
            <v-layout row wrap>
                <span id="test">js testler</span>

                <v-btn @click="testet()" color="info">Test et</v-btn>


            </v-layout>
          </v-card>


        </v-container>
      </v-layout>

    </v-card>
  </v-app>
</div>
</template>

<script>
import acenteisteklistesiVue from '../coper/clinista/acenteisteklistesi.vue';
export default {
  data() {
    return {
    }
  },

  components: {
  },
  mounted() { },
  watch: {},
  methods: {
      testet(){
          document.getElementById("test").style.fontSize="50px";
          var carName = "Volvo";
document.getElementById("test").innerHTML = carName;

      },
  }
}

</script>

<style>
</style>
